import Util from '@/util';

const routes = {
  sales: [
    {
      name: 'traffic_details',
      path: 'traffic_details',
      component: Util.loadPage('Sales/TrafficDetails'),
      meta: {
        title: 'Traffic Details',
        requiresPermissions: ['view_transaction'],
      },
    },
    {
      name: 'traffic_analysis',
      path: 'traffic_analysis',
      component: Util.loadPage('Sales/TrafficAnalysis'),
      meta: {
        title: 'Traffic Analysis',
        requiresPermissions: ['view_transaction'],
      },
    },
    {
      name: 'settings',
      path: 'settings',
      component: Util.loadPage('Sales/Settings'),
      meta: {
        title: 'Settings',
        requiresPermissions: ['view_transaction'],
      },
    },
  ],
  support: [
    {
      name: 'transactions',
      path: 'transactions',
      component: Util.loadPage('Support/Transactions'),
      meta: {
        title: 'Transactions',
        requiresPermissions: ['view_transaction'],
      },
    },
  ],
};

export default routes;
